import { createTheme } from '@mui/material/styles';

export const getTheme = (mode) => createTheme({
  palette: {
    mode,
    primary: {
      main: mode === 'dark' ? '#ffffff' : '#212121',
    },
    secondary: {
      main: '#757575',
    },
    background: {
      default: mode === 'dark' ? '#121212' : '#ffffff',
      paper: mode === 'dark' ? '#1e1e1e' : '#ffffff',
    },
    divider: mode === 'dark' ? '#333333' : '#e0e0e0',
  },
  shadows: Array(25).fill('none'), // Disable all Material UI default shadows
  spacing: 8,
  typography: {
    fontFamily: [
      '"Pretendard Variable"',
      '"Pretendard"',
      '"Noto Sans KR"',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: {
      fontFamily: '"Playfair Display", serif',
      fontSize: '2.25rem',
      fontWeight: 700,
      lineHeight: 1.2,
      letterSpacing: '-0.02em',
      marginBottom: '0.5rem',
    },
    h2: {
      fontFamily: '"Playfair Display", serif',
      fontSize: '1.8rem',
      fontWeight: 700,
      lineHeight: 1.2,
      letterSpacing: '-0.02em',
      marginBottom: '0.5rem',
    },
    h3: {
      fontFamily: '"Playfair Display", serif',
      fontSize: '1.5rem',
      fontWeight: 700,
      lineHeight: 1.3,
      letterSpacing: '-0.02em',
      marginBottom: '0.5rem',
    },
    h4: {
      fontSize: '1.25rem',
      fontWeight: 600,
      lineHeight: 1.3,
      letterSpacing: '-0.01em',
      textTransform: 'uppercase',
      marginBottom: '0.25rem',
    },
    h5: {
      fontSize: '1.1rem',
      fontWeight: 600,
      lineHeight: 1.4,
      marginBottom: '0.25rem',
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 600,
      lineHeight: 1.4,
      marginBottom: '0.25rem',
    },
    body1: {
      fontFamily: '"Lora", serif',
      fontSize: '1rem',
      lineHeight: 1.6,
      marginBottom: '0.25rem',
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.4,
      marginBottom: '0.25rem',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontSize: '16px',
        },
        body: {
          fontSize: '1rem',
          lineHeight: 1.4,
        }
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          backgroundColor: mode === 'dark' ? '#121212' : '#ffffff',
          color: mode === 'dark' ? '#ffffff' : '#212121',
          borderBottom: `1px solid ${mode === 'dark' ? '#333333' : '#e0e0e0'}`,
          backgroundImage: 'none',
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: mode === 'dark' ? '#1e1e1e' : '#fff',
          borderRadius: '8px',
          boxShadow: 'none',
          border: `1px solid ${mode === 'dark' ? '#333333' : '#e0e0e0'}`,
          backgroundImage: 'none',
        },
      },
    },
    MuiPaper: {
      defaultProps: {
        elevation: 0
      },
      styleOverrides: {
        root: {
          borderRadius: '8px',
          boxShadow: 'none',
          border: `1px solid ${mode === 'dark' ? '#333333' : '#e0e0e0'}`,
          backgroundImage: 'none'
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          paddingLeft: '12px',
          paddingRight: '12px',
          '@media (min-width: 600px)': {
            paddingLeft: '16px',
            paddingRight: '16px',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '4px',
          textTransform: 'none',
          fontWeight: 600,
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
          padding: '6px 16px',
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
        sizeLarge: {
          padding: '8px 24px',
        },
        sizeSmall: {
          padding: '4px 12px',
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          padding: '16px 24px',
          fontFamily: '"Playfair Display", serif',
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: '16px 24px',
          '&:first-of-type': {
            paddingTop: '16px',
          },
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: '8px 24px 16px',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: '12px 16px',
          borderBottom: `1px solid ${mode === 'dark' ? '#333333' : '#e0e0e0'}`,
        },
        head: {
          fontWeight: 600,
          color: mode === 'dark' ? '#aaaaaa' : '#757575',
        },
        sizeSmall: {
          padding: '6px 12px',
        },
      },
    },
    MuiDialog: {
      defaultProps: {
        PaperProps: {
          elevation: 0
        }
      },
      styleOverrides: {
        paper: {
          borderRadius: '12px',
          boxShadow: mode === 'dark' ? '0 8px 32px rgba(0,0,0,0.4)' : '0 8px 32px rgba(0,0,0,0.1)',
          backgroundImage: 'none',
          border: `1px solid ${mode === 'dark' ? '#333333' : '#e0e0e0'}`,
        }
      }
    },
  },
}); 